import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import DehazeIcon from '@mui/icons-material/Dehaze';
// import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CloseIcon from '@mui/icons-material/Close';

// eslint-disable-next-line import/no-unresolved
// import Logo from 'components/logo';
import { Link } from 'react-router-dom';

import DreamCarIcon from '../appBarIcons/dreamCar';

export const SpecialTemporaryDrawer = ({ special }) => {
  const [state, setState] = React.useState({
    left: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const navItems = [
    {
      name: 'Home',
      link: '/inspection',
    },
    {
      name: 'Explore Pre-owned Cars',
      link: '/home',
    },
    {
      name: 'Inspection Report',
      link: '/verify',
    },
  ];

  const list = (anchor) => (
    <Box
      sx={{
        width: 250,
        backgroundColor: 'white',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'space-between',
      }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <Box>
        {/* <Logo /> */}
        <List>
          {navItems?.map((text, index) => (
            <ListItem key={index} disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  {text?.name === 'Home' ? (
                    // <HomeIcon />
                    <img src="/assets/images/iconImages/yellowHome.png" alt="Inspection" width={28} height={28} />
                  ) : text?.name === 'Explore Pre-owned Cars' ? (
                    // <BuyIcon />
                    <img src="/assets/images/iconImages/iconInspection.png" alt="Inspection" width={28} height={28} />
                  ) : text?.name === 'Inspection Report' ? (
                    // <CarInspectionIcon />
                    <img src="/assets/images/iconImages/reportYellow.png" alt="Inspection" width={28} height={28} />
                  ) : (
                    <DreamCarIcon />
                  )}
                </ListItemIcon>
                <Link to={text?.link} style={{ textDecoration: 'none' }}>
                  <ListItemText primary={text?.name} sx={{ color: 'black !important' }} />
                </Link>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
      <CloseIcon fontSize="large" style={{ paddingTop: '10px', paddingRight: '10px', color: 'black' }} />
    </Box>
  );

  return (
    <div>
      {['left'].map((anchor) => (
        <React.Fragment key={anchor}>
          <Button
            className="header-button"
            onClick={toggleDrawer(anchor, true)}
            style={{ color: special ? 'black' : 'black', minWidth: '43px' }}
          >
            {' '}
            <DehazeIcon fontSize="large" />
          </Button>
          <Drawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)} className="nav-drawer">
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
};

SpecialTemporaryDrawer.propTypes = {
  special: PropTypes.any,
};
